import { render } from "./UserProfileLayout.vue?vue&type=template&id=b9377a5a&scoped=true"
import script from "./UserProfileLayout.vue?vue&type=script&lang=js"
export * from "./UserProfileLayout.vue?vue&type=script&lang=js"

import "./UserProfileLayout.vue?vue&type=style&index=0&id=b9377a5a&lang=scss"
import "./UserProfileLayout.vue?vue&type=style&index=1&id=b9377a5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b9377a5a"

export default script